"use strict";

var _classCallCheck = require("/home/runner/work/online-shopper-web/online-shopper-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/online-shopper-web/online-shopper-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _get = require("/home/runner/work/online-shopper-web/online-shopper-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _getPrototypeOf = require("/home/runner/work/online-shopper-web/online-shopper-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/runner/work/online-shopper-web/online-shopper-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/home/runner/work/online-shopper-web/online-shopper-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CodeGen = exports.Name = exports.nil = exports.stringify = exports.str = exports._ = exports.KeywordCxt = void 0;

var core_1 = require("./core");

var draft7_1 = require("./vocabularies/draft7");

var discriminator_1 = require("./vocabularies/discriminator");

var draft7MetaSchema = require("./refs/json-schema-draft-07.json");

var META_SUPPORT_DATA = ["/properties"];
var META_SCHEMA_ID = "http://json-schema.org/draft-07/schema";

var Ajv = /*#__PURE__*/function (_core_1$default) {
  _inherits(Ajv, _core_1$default);

  var _super = _createSuper(Ajv);

  function Ajv() {
    _classCallCheck(this, Ajv);

    return _super.apply(this, arguments);
  }

  _createClass(Ajv, [{
    key: "_addVocabularies",
    value: function _addVocabularies() {
      var _this = this;

      _get(_getPrototypeOf(Ajv.prototype), "_addVocabularies", this).call(this);

      draft7_1.default.forEach(function (v) {
        return _this.addVocabulary(v);
      });
      if (this.opts.discriminator) this.addKeyword(discriminator_1.default);
    }
  }, {
    key: "_addDefaultMetaSchema",
    value: function _addDefaultMetaSchema() {
      _get(_getPrototypeOf(Ajv.prototype), "_addDefaultMetaSchema", this).call(this);

      if (!this.opts.meta) return;
      var metaSchema = this.opts.$data ? this.$dataMetaSchema(draft7MetaSchema, META_SUPPORT_DATA) : draft7MetaSchema;
      this.addMetaSchema(metaSchema, META_SCHEMA_ID, false);
      this.refs["http://json-schema.org/schema"] = META_SCHEMA_ID;
    }
  }, {
    key: "defaultMeta",
    value: function defaultMeta() {
      return this.opts.defaultMeta = _get(_getPrototypeOf(Ajv.prototype), "defaultMeta", this).call(this) || (this.getSchema(META_SCHEMA_ID) ? META_SCHEMA_ID : undefined);
    }
  }]);

  return Ajv;
}(core_1.default);

module.exports = exports = Ajv;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Ajv;

var validate_1 = require("./compile/validate");

Object.defineProperty(exports, "KeywordCxt", {
  enumerable: true,
  get: function get() {
    return validate_1.KeywordCxt;
  }
});

var codegen_1 = require("./compile/codegen");

Object.defineProperty(exports, "_", {
  enumerable: true,
  get: function get() {
    return codegen_1._;
  }
});
Object.defineProperty(exports, "str", {
  enumerable: true,
  get: function get() {
    return codegen_1.str;
  }
});
Object.defineProperty(exports, "stringify", {
  enumerable: true,
  get: function get() {
    return codegen_1.stringify;
  }
});
Object.defineProperty(exports, "nil", {
  enumerable: true,
  get: function get() {
    return codegen_1.nil;
  }
});
Object.defineProperty(exports, "Name", {
  enumerable: true,
  get: function get() {
    return codegen_1.Name;
  }
});
Object.defineProperty(exports, "CodeGen", {
  enumerable: true,
  get: function get() {
    return codegen_1.CodeGen;
  }
});